import { apiRTK, Tag } from 'api/api-rtk'

import type { Body } from './types'

export const api = apiRTK.injectEndpoints({
	endpoints: create => ({
		sync: create.mutation<unknown, Body>({
			invalidatesTags: [Tag.Subscription],
			query: data => ({
				data,
				method: 'POST',
				url: 'orders/sync'
			})
		})
	}),
	overrideExisting: true
})
